import React, { useState, useMemo } from 'react'
import { Grid, Header, Button, Modal } from 'semantic-ui-react'
import ESignRequestsTable from '../../../components/Documents/ESignRequestsTable'
import ESignTemplatesTable from '../../../components/Documents/ESignTemplatesTable'
import DocumentTable from '../../../components/Documents/DocumentTable'
import PageHeader from '../../../components/PageHeader/PageHeader'
import env from '../../../env'
import { hasPermission } from '../../../lib/utils/utils'
import { useSelector } from 'react-redux'
import TemplateEditor from '../../../components/Documents/Anvil/TemplateEditor'
import DocumentTemplateList from '../../../components/Documents/Anvil/DocumentTemplateList'

const AdminDocuments = (props) => {
  const user = useSelector((state) => state.user.user)
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const canDelete = hasPermission(user, 'Delete Document')
  const globalSettings = useSelector((state) => state.globals.globalSettings)
  const [activeItem, setActiveItem] = useState(
    globalSettings?.document_service === 'Box'
      ? 'E-Sign Templates'
      : 'Document Templates'
  )
  const items = useMemo(() => {
    if (globalSettings?.document_service === 'Box') {
      return ['E-Sign Templates', 'E-Sign Requests', 'Documents']
    } else if (globalSettings?.document_service === 'Anvil') {
      return ['Document Templates', 'E-Sign Requests', 'Documents']
    }
  })
  return (
    <div className={'main-container'} id="admin-dashboard">
      <Grid stackable>
        <Grid.Row className={'no-bottom-margin no-bottom-padding'}>
          <Grid.Column
            width={16}
            className={'no-bottom-margin no-bottom-padding'}
          >
            <PageHeader
              header={'Documents'}
              className={
                'no-bottom-margin no-bottom-padding no-top-margin no-top-padding'
              }
              dividerClassName={'no-bottom-margin no-bottom-padding'}
            />
            {/* <Button color={'green'} style={{float: 'right', marginRight: '20px'}}>Add E-Sign Template</Button> */}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16} style={{ paddingLeft: '25px' }}>
            <div className="exchange-table-heading">
              <div className="commodities-wrapper">
                {items?.map((item) => {
                  return (
                    <Header
                      as={'h2'}
                      className={
                        activeItem === item
                          ? 'commodity-header selected'
                          : 'commodity-header'
                      }
                      color={activeItem === item ? 'primary' : 'black'}
                      onClick={() => setActiveItem(item)}
                      style={{
                        margin: '0 1rem 1rem 0',
                        '--primaryColor': tenant?.deployment_primary_color,
                      }}
                    >
                      {item}
                    </Header>
                  )
                })}
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        {activeItem === 'Document Templates' && (
          <DocumentTemplateList hideHeader />
        )}
        {activeItem === 'E-Sign Templates' && (
          <ESignTemplatesTable hideHeader />
        )}
        {activeItem === 'E-Sign Requests' && (
          <ESignRequestsTable generationDescription hideHeader />
        )}
        {activeItem === 'Documents' && (
          <Grid.Row className={'no-bottom-margin no-bottom-padding'}>
            <Grid.Column width={16}>
              <DocumentTable hideHeader canDelete={canDelete} />
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </div>
  )
}

export default AdminDocuments
